import React from "react";
const useIsPrerender = () => {
  const [isPrerender, setIsPrerender] = React.useState(true);
  React.useEffect(() => {
    setIsPrerender(false);
  }, []);
  return isPrerender;
};
export {
  useIsPrerender
};
//# sourceMappingURL=use-prerender.js.map
